module.exports = __webpack_public_path__ + "static/media/hilux-mk9-2021.3c0ad5a0.webp";